<nb-layout windowMode>
  <nb-layout-header fixed>
    <bf-header class="w-100"></bf-header>
  </nb-layout-header>
  <nb-sidebar start containerFixed="true">
    <bf-sidebar></bf-sidebar>
  </nb-sidebar>
  <nb-layout-column class="p-4">
    <router-outlet #outlet="outlet"></router-outlet>
  </nb-layout-column>
</nb-layout>

<div *ngIf="showZoomRecommendationNotice" class="zoom-recommendation-notice"
  [class.zoom-recommendation-notice--closing]="isZoomRecommendationNoticeClosing" role="status" aria-live="polite">
  <div class="zoom-recommendation-notice__content">
    <strong>Recomendacion visual</strong>
    <span>Para optimizar la experiencia de uso dentro del sistema, reduzca el zoom del navegador al 80%.</span>
  </div>
  <button type="button" class="zoom-recommendation-notice__close" aria-label="Cerrar recomendacion visual"
    (click)="closeZoomRecommendationNotice()">
    &times;
  </button>
</div>

<ng-container *ngIf="isColegio">
  <bf-legal-terms-modal *ngIf="showLegalTermsModal" [isSaving]="isAcceptingLegalTerms" (accept)="acceptLegalTerms()"
    (cancel)="cancelLegalTerms()"></bf-legal-terms-modal>
</ng-container>
